module.exports = __webpack_public_path__ + "static/media/hbb_grid_5.c8dd986c.png";